import {
  Button,
  Container,
  Image,
  Nav,
  Navbar,
  Offcanvas,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import defaultLogo from "../../../Assets/Images/Logo/Ideal_Corporate_Services.png";
import { useState } from "react";
import { MdMenuOpen } from "react-icons/md";
import { LuArrowUpRight, LuChevronDown } from "react-icons/lu";
import { primaryColor, secondaryColor } from "../../../Constants/Colors";
import { useGetServicesQuery } from "../../../redux/api/ServicesApi/servicesApi";
import { useGetSettingsQuery } from "../../../redux/api/SettingsApi/settingsApi";

const Header = () => {
  const [show, setShow] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const location = useLocation();
  const navigate = useNavigate();

  const { data: servicesData } = useGetServicesQuery({ limit: 100 });
  const { data: settings } = useGetSettingsQuery();

  // Updated isActive function to handle nested routes
  const isActive = (path, hasDropdown = false) => {
    if (hasDropdown) {
      // For services menu, check if current path starts with /services
      return location.pathname.startsWith("/services");
    }
    return location.pathname === path;
  };

  // Services data dynamically fetched
  const services = (servicesData?.services || [])
    .filter((s) => s.status)
    .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
    .map((s) => ({
      title: s.service_title,
      description: s.service_menu_description,
      path: `/services/${s.service_slug}`,
    }));

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/aboutUs" },
    { label: "Services", hasDropdown: true },
    { label: "Works", path: "/works" },
    { label: "Careers", path: "/careers" },
    { label: "Blogs", path: "/blogs" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (show) {
      handleClose();
    }
    setShowDropdown(false);
  };

  const handleServicesHover = () => {
    setShowDropdown(true);
  };

  const handleServicesLeave = (e) => {
    setTimeout(() => {
      const dropdown = document.querySelector(".services-dropdown");
      const servicesLink = document.querySelector(".services-nav-item");

      if (!dropdown?.matches(":hover") && !servicesLink?.matches(":hover")) {
        setShowDropdown(false);
      }
    }, 500);
  };

  const currentLogo = settings?.logo || defaultLogo;

  const renderNavLinks = (mobile = false) => {
    return navLinks.map((link) => {
      if (link.hasDropdown && !mobile) {
        return (
          <div
            key={link.path}
            className="position-relative services-nav-item"
            onMouseEnter={handleServicesHover}
            onMouseLeave={handleServicesLeave}
          >
            <Nav.Link
              className={`mx-1 rounded-5 px-4 fw-medium text-dark nav-link-custom d-flex align-items-center ${
                isActive(link.path, link.hasDropdown) ? "active" : ""
              }`}
              style={{
                fontSize: "18px",
                position: "relative",
                transition: "color 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => handleNavigation(link.path)}
            >
              {link.label}
              <LuChevronDown className="ms-1" />
            </Nav.Link>
          </div>
        );
      }

      return (
        <Nav.Link
          key={link.path}
          className={`${
            mobile ? "py-2" : "mx-1 rounded-5 px-4"
          } fw-medium text-dark nav-link-custom ${
            isActive(link.path, link.hasDropdown) ? "active" : ""
          }`}
          style={{
            fontSize: mobile ? "14px" : "18px",
            position: "relative",
            transition: "color 0.3s ease",
            cursor: "pointer",
          }}
          onClick={() => handleNavigation(link.path)}
        >
          {link.label}
        </Nav.Link>
      );
    });
  };

  const renderServicesDropdown = () => {
    if (!showDropdown) return null;

    return (
      <div
        className="position-fixed w-100 bg-white shadow-lg border-top services-dropdown"
        style={{
          top: "105px",
          left: 0,
          zIndex: 1050,
          borderTop: `3px solid ${secondaryColor}`,
          paddingTop: "15px",
        }}
        onMouseEnter={() => setShowDropdown(true)}
        onMouseLeave={handleServicesLeave}
      >
        <Container className="py-4">
          <Row>
            <Col lg={10} className="m-auto">
              <Row>
                {services.map((service, index) => (
                  <Col md={6} lg={4} key={index} className="mb-3">
                    <div
                      className="service-item arrowLauncher-container p-3 h-100 rounded-3 border"
                      style={{
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        backgroundColor: "#f8f9fa",
                      }}
                      onClick={() => handleNavigation(service.path)}
                      onMouseEnter={(e) => {
                        const item = e.target.closest(".service-item");
                        if (item) {
                          item.style.backgroundColor = "#e9ecef";
                          item.style.transform = "translateY(-2px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        const item = e.target.closest(".service-item");
                        if (item) {
                          item.style.backgroundColor = "#f8f9fa";
                          item.style.transform = "translateY(0)";
                        }
                      }}
                    >
                      <h6
                        className="fw-bold mb-2"
                        style={{ color: primaryColor }}
                      >
                        {service.title}{" "}
                        <span className="float-end">
                          <LuArrowUpRight className="ms-2 fs-4 arrowLauncher" />
                        </span>
                      </h6>
                      <p className="text-muted small mb-0">
                        {service.description}
                      </p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  };

  const renderDesktopNavigation = () => {
    return (
      <Container className="d-flex align-items-center justify-content-between">
        {/* Logo */}
        <Navbar.Brand
          className="me-0 me-lg-4"
          onClick={() => handleNavigation("/")}
          style={{ cursor: "pointer" }}
        >
          <Image
            src={currentLogo}
            height="80"
            width="150"
            className="d-inline-block align-top"
            alt="Ideal Logo"
            style={{ objectFit: "contain" }}
          />
        </Navbar.Brand>
        <Nav>{renderNavLinks()}</Nav>

        <Button
          variant="rounded-5 arrowLauncher-container"
          onClick={() => navigate("/contactUs")}
          className="d-flex align-items-center fw-bold"
          style={{ backgroundColor: secondaryColor }}
        >
          Contact Us
          <LuArrowUpRight className="ms-2 fs-4 arrowLauncher" />
        </Button>
      </Container>
    );
  };

  const renderMobileNavigation = () => {
    return (
      <Container className="d-flex d-xl-none align-items-center justify-content-between py-2">
        {/* Mobile Logo */}
        <Navbar.Brand
          onClick={() => handleNavigation("/")}
          style={{ cursor: "pointer" }}
        >
          <Image
            src={currentLogo}
            height="60"
            width="90"
            className="d-inline-block align-top"
            alt="Ideal Logo"
            style={{ objectFit: "contain" }}
          />
        </Navbar.Brand>

        {/* Mobile Menu Button */}
        <Button
          variant="outline-secondary border-2"
          onClick={handleShow}
          className="d-flex align-items-center px-2 py-1"
        >
          <MdMenuOpen className="fs-2" />
        </Button>
      </Container>
    );
  };

  const renderMobileServicesSubmenu = () => {
    return (
      <div className="ms-3 mt-2">
        {services.map((service, index) => (
          <Nav.Link
            key={index}
            className="py-2 fw-medium text-muted nav-link-custom"
            style={{
              fontSize: "13px",
              cursor: "pointer",
            }}
            onClick={() => handleNavigation(service.path)}
          >
            {service.title}
          </Nav.Link>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="sticky-top">
        <Navbar bg="white" className="py-1 border-bottom">
          {/* Desktop Navigation */}
          <div className="d-none d-xl-block w-100">
            {renderDesktopNavigation()}
          </div>

          {/* Mobile Navigation */}
          {renderMobileNavigation()}
        </Navbar>
        {/* Services Dropdown for Desktop */}
        {renderServicesDropdown()}
      </div>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="offcanvas-menu"
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title>
            <Image
              src={currentLogo}
              height="50"
              className="d-inline-block align-top"
              alt="Ideal Logo"
              style={{ objectFit: "contain" }}
            />
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="d-flex flex-column">
          {/* Navigation Links */}
          <div className="navigation-section mb-4">
            <Nav className="flex-column gap-1">
              {navLinks.map((link) => (
                <div key={link.path}>
                  <Nav.Link
                    className={`py-2 fw-medium text-dark nav-link-custom ${
                      isActive(link.path, link.hasDropdown) ? "active" : ""
                    }`}
                    style={{
                      fontSize: "14px",
                      position: "relative",
                      transition: "color 0.3s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => handleNavigation(link.path)}
                  >
                    {link.label}
                  </Nav.Link>
                  {link.hasDropdown && renderMobileServicesSubmenu()}
                </div>
              ))}
            </Nav>
          </div>
          <Button
            variant="rounded-5"
            onClick={() => navigate("/contactUs")}
            className="d-inline align-items-center fw-bold"
            style={{ backgroundColor: secondaryColor }}
          >
            Contact Us
            <LuArrowUpRight className="ms-2 fs-4" />
          </Button>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Custom Styles */}
      <style>{`
        .nav-link-custom.active {
          background-color: ${secondaryColor} !important;
          color: black !important;
        }
      `}</style>
    </>
  );
};

export default Header;
